<template>
  <div class="row bg-white">
    <div class="col-md-12">
      <div class="d-flex justify-content-between" style="padding:0.5em">
        <div class="">
          <h3 class="text-info text-capitalize">{{ client.name }}</h3>
        </div>
        <div v-if="!client.provider && company_default.permission != 5">
          <vs-button
            type="gradient"
            @click="newDocument('invoice')"
            v-if="!client.generic"
          >
            <i class="fa fa-plus"></i>
            Nueva Factura
          </vs-button>
          <vs-button
            type="gradient"
            class="ml-2"
            @click="newDocument('ticket')"
          >
            <i class="fa fa-plus"></i>
            Nuevo Tiquete
          </vs-button>
        </div>
      </div>

      <div
        class="d-flex justify-content-end"
        v-if="!client.provider && company_default.permission != 5"
      >
        <span style="position:absolute;right:10px;bottom:-40px;">
          <h4 class="font-weight-bold" style="color: rgb(255, 130, 0)">
            Balance:
            {{ client.balance | currency({symbol: current_currency.symbol,fractionCount: 2}) }}
          </h4>
        </span>
      </div>
    </div>
    <br />
    
    <vs-tabs>
      <vs-tab label="Información" icon-pack="feather" icon="icon-user">
        <div class="tab-content">
                      <form @submit.prevent="updateClient">
              <div class="row">
               <div class="col-md-6">
                 <div class="card">
                   <div class="card-header bg-white">
                     <h4 class="card-title">
                       <i class="fa fa-user"></i>
                       Información General
                     </h4>
                   </div>

                   <div class="card-body">
                     <text-input
                       name="name"
                       :label="'Nombre'"
                       v-validate="'required'"
                       :error="errors.first('name')"
                       v-model="client.name"
                       data-vv-as="Nombre"
                     >
                     </text-input>

                     <text-input
                       name="comercial_name"
                       :label="'Nombre Comercial'"
                       v-model="client.comercial_name"
                       data-vv-as="Nombre Comercial"
                     >
                     </text-input>

                     <div
                       :class="[
                         'form-group',
                         { 'has-danger': errors.has('identification_type') }
                       ]"
                     >
                       <label>Tipo de Identificación</label>
                       <el-select
                         v-model="client.identification_type"
                         name="identification_type"
                         v-validate="'required'"
                         placeholder=""
                         class="form-control"
                       >
                         <el-option
                          v-for="identification_type in identification_types"
                          :value="identification_type.code || identification_type.value"
                          :key="identification_type.code || identification_type.value"
                          :label="identification_type.name || identification_type.text"
                         >
                         </el-option>
                       </el-select>
                       <label v-show="errors.has('identification_type')" class="error">
                         {{ errors.first("identification_type") }}
                       </label>
                     </div>

                     <text-input
                       name="identification"
                       :label="'Identificación'"
                       v-validate="rulesIdentification"
                       :error="errors.first('identification')"
                       v-model="client.identification"
                       data-vv-as="Identificación"
                     >
                     </text-input>

                     <div v-if="client.identification_type == '02' || client.identification_type == '01'">
                       <label>Actividad Económica</label>
                       <div class="mb-3 d-flex" style="gap: 10px;">
                         <el-tooltip content="Buscar actividades económicas" placement="top">
                           <vs-button
                             type="gradient"
                             icon
                             @click="lookupActivities"
                             :disabled="!client.identification"
                           >
                             <i class="fa fa-search"></i>
                           </vs-button>
                         </el-tooltip>
                         
                         <el-tooltip content="Agregar actividad manualmente" placement="top">
                           <vs-button
                             type="gradient"
                             icon
                             @click="openManualActivityDialog"
                           >
                             <i class="fa fa-plus"></i>
                           </vs-button>
                         </el-tooltip>
                       </div>

                       <div v-if="client.identification_type == '02' || client.identification_type == '01'">
                         <!-- Si el cliente ya tiene actividades guardadas, mostrar solo esas -->
                         <div v-if="client.economic_activity && client.economic_activity.length > 0">
                           <el-select
                             :value="selectedEconomicActivities"
                             @input="updateSelectedActivities"
                             name="economic_activity"
                             placeholder="Actividades económicas del cliente"
                             multiple
                             collapse-tags
                             class="form-control"
                           >
                             <el-option
                               v-for="activity in client.economic_activity"
                               :value="activity"
                               :key="activity.id"
                               :label="activity.id"
                             >
                               <el-tooltip :content="(activity.descripcion || activity.name)" placement="right">
                                 <span>{{ activity.id }}</span>
                               </el-tooltip>
                             </el-option>
                           </el-select>
                         </div>
                         
                         <!-- Modo de edición o cuando no hay actividades -->
                         <div v-else-if="enableActivityEditing || (!client.economic_activity || client.economic_activity.length === 0)">
                           <el-select
                             :value="selectedEconomicActivities"
                             @input="updateSelectedActivities"
                             name="economic_activity"
                             placeholder="Seleccione actividad (opcional)"
                             filterable
                             multiple
                             collapse-tags
                             class="form-control"
                           >
                             <el-option
                               v-for="economic_activity in availableActivities"
                               :value="economic_activity"
                               :key="economic_activity.id"
                               :label="economic_activity.id"
                             >
                               <el-tooltip :content="(economic_activity.descripcion || economic_activity.name)" placement="right">
                                 <span>{{ economic_activity.id }} - {{ economic_activity.descripcion || economic_activity.name }}</span>
                               </el-tooltip>
                             </el-option>
                           </el-select>
                           
                           <div class="mt-2" v-if="enableActivityEditing">
                             <button 
                               type="button" 
                               class="btn btn-sm btn-outline-secondary mr-2"
                               @click="cancelActivityEditing"
                             >
                               <i class="fa fa-times"></i> Cancelar
                             </button>
                             <button 
                               type="button" 
                               class="btn btn-sm btn-outline-success"
                               @click="saveActivityChanges"
                             >
                               <i class="fa fa-check"></i> Guardar cambios
                             </button>
                           </div>
                         </div>


                       </div>

                       <div v-else>
                         <el-select
                           v-model="client.economic_activity"
                           name="economic_activity"
                           value-key="id"
                           v-validate="'required'"
                           placeholder=""
                           filterable
                           class="form-control"
                         >
                           <el-option
                             v-for="economic_activity in economic_activities"
                             :value="economic_activity"
                             :key="economic_activity.id"
                             :label="economic_activity.name"
                           >
                           </el-option>
                         </el-select>
                       </div>

                       <label
                         v-show="errors.has('economic_activity')"
                         class="error"
                       >
                         {{ errors.first("economic_activity") }}
                       </label>
                     </div>

                     <text-input
                       name="email"
                       :label="'Email Principal'"
                       v-validate="'required|email'"
                       :error="errors.first('email')"
                       v-model="client.email"
                     >
                     </text-input>

                     <text-input
                       name="phone"
                       :label="'Teléfono'"
                       v-validate="'required|integer'"
                       :error="errors.first('phone')"
                       v-model="client.phone"
                     >
                     </text-input>

                     <text-input
                       name="address"
                       :label="'Dirección'"
                       v-validate="'required'"
                       :error="errors.first('address')"
                       v-model="client.address"
                       data-vv-as="Dirección"
                     >
                     </text-input>
                   </div>
                 </div>
               </div>

               <div class="col-md-6">
                 <div class="card">
                   <div class="card-header bg-white">
                     <h4 class="card-title">
                       <i class="fa fa-map"></i>
                       Ubicación
                     </h4>
                   </div>

                   <div class="card-body">
                     <div class="row">
                       <div class="col-md-12">
                         <div
                           :class="[
                             'form-group',
                             { 'has-danger': errors.has('country') }
                           ]"
                         >
                           <label>País</label>
                           <el-select
                             v-model="client.country"
                             name="country"
                             value-key="id"
                             v-validate="'required'"
                             placeholder=""
                             filterable
                             class="form-control"
                           >
                             <el-option
                               v-for="country in countries"
                               :value="country"
                               :key="country.code"
                               :label="country.name"
                             >
                             </el-option>
                           </el-select>
                           <label v-show="errors.has('country')" class="error">
                             {{ errors.first("country") }}
                           </label>
                         </div>
                       </div>
                       
                       <div class="col-md-6" v-show="showProvinceCantonDistrict">
                         <div
                           :class="[
                             'form-group',
                             { 'has-danger': errors.has('province') }
                           ]"
                         >
                           <label>Provincia</label>
                           <el-select
                             @change="getProvinces()"
                             v-model="client.province"
                             value-key="number"
                             name="province"
                             v-validate="'required'"
                             placeholder=""
                             filterable
                             class="form-control"
                           >
                             <el-option
                               :data-valor="province.number"
                               v-for="province in provinces"
                               :selected="province.id == 1 ? 'selected' : ''"
                               :value="province"
                               :key="province.number"
                               :label="province.name"
                             >
                             </el-option>
                           </el-select>
                           <label v-show="errors.has('province')" class="error">
                             {{ errors.first("province") }}
                           </label>
                         </div>

                         <div
                           :class="[
                             'form-group',
                             { 'has-danger': errors.has('canton') }
                           ]"
                         >
                           <label>Cantón</label>
                           <el-select
                             @change="getCantons()"
                             value-key="number"
                             v-model="client.canton"
                             name="canton"
                             v-validate="'required'"
                             placeholder=""
                             filterable
                             class="form-control"
                           >
                             <el-option
                               :data-province="canton.province_number"
                               :data-canton="canton.number"
                               v-for="canton in cantons"
                               :value="canton"
                               :key="canton.number"
                               :label="canton.name"
                             >
                             </el-option>
                           </el-select>
                           <label v-show="errors.has('canton')" class="error">
                             {{ errors.first("canton") }}
                           </label>
                         </div>
                       </div>
                       
                       <div class="col-md-6" v-show="showProvinceCantonDistrict">
                         <div
                           :class="[
                             'form-group',
                             { 'has-danger': errors.has('district') }
                           ]"
                         >
                           <label>Distrito</label>
                           <el-select
                             v-model="client.district"
                             value-key="number"
                             name="district"
                             v-validate="'required'"
                             placeholder=""
                             filterable
                             class="form-control"
                             @change="getBarrios()"
                           >
                             <el-option
                               v-for="district in districts"
                               :value="district"
                               :key="district.number"
                               :label="district.name"
                             >
                             </el-option>
                           </el-select>
                           <label v-show="errors.has('district')" class="error">
                             {{ errors.first("district") }}
                           </label>
                         </div>

                         <div
                           :class="[
                             'form-group',
                             { 'has-danger': errors.has('barrio') }
                           ]"
                         >
                           <label>Barrio</label>
                           <el-select
                             v-model="client.barrio"
                             value-key="id"
                             name="barrio"
                             v-validate="'required'"
                             placeholder=""
                             filterable
                             class="form-control"
                             popper-class="el-select-float"
                           >
                             <el-option
                               v-for="barrio in barrios"
                               :value="barrio"
                               :key="barrio.id"
                               :label="barrio.name"
                             >
                             </el-option>
                           </el-select>
                           <label v-show="errors.has('barrio')" class="error">
                             {{ errors.first("barrio") }}
                           </label>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
             </div>

                         <hr />
             <div class="row">
               <h3 class="separator-horizontal">
                 Contactos
               </h3>
             </div>
             
             <div class="row">
               <div class="col-md-12">
                 <div class="card">
                   <div class="card-header bg-white">
                     <h4 class="card-title">
                       <i class="fa fa-users"></i>
                       Contactos
                     </h4>
                   </div>

                   <div class="card-body">
                     <div
                       v-for="(contact, index) in contacts"
                       :key="index"
                       class="mb-3"
                     >
                       <h5 v-if="contacts.length > 1">Contacto {{ index + 1 }}</h5>
                       
                       <div class="row">
                         <div class="col-md-4">
                           <text-input
                             :name="'name_' + index"
                             :label="'Nombre'"
                             v-validate="
                               `${
                                 contacts[index].email.length > 0 ? 'required' : ''
                               }`
                             "
                             :error="errors.first('name_' + index)"
                             v-model="contacts[index].name"
                             data-vv-as="Nombre"
                           >
                           </text-input>
                         </div>

                         <div class="col-md-4">
                           <text-input
                             :name="'email_' + index"
                             :label="'Email'"
                             v-validate="
                               `${
                                 contacts[index].name.length > 0
                                   ? 'required|email'
                                   : 'email'
                               }`
                             "
                             :error="errors.first('email_' + index)"
                             v-model="contacts[index].email"
                             data-vv-as="Email"
                           >
                           </text-input>
                         </div>

                         <div class="col-md-4">
                           <text-input
                             :name="'workstation_' + index"
                             :label="'Puesto de trabajo'"
                             v-model="contacts[index].workstation"
                             data-vv-as="Puesto de trabajo"
                           >
                           </text-input>
                         </div>
                       </div>

                       <div class="row">
                         <div class="col-md-12">
                           <vs-checkbox
                             v-model="contacts[index].send_copy_email_invoices"
                             vs-value="true"
                           >
                             Desea enviar copia de la factura
                           </vs-checkbox>

                           <button
                             v-show="!notRemoveContact"
                             type="button"
                             class="btn btn-link text-danger"
                             @click="removeContact(index)"
                           >
                             - Remover contacto
                           </button>
                         </div>
                       </div>
                       
                       <hr v-if="index < contacts.length - 1" />
                     </div>
                     
                     <button
                       type="button"
                       class="btn btn-link text-success"
                       @click="addContact(contacts.length)"
                     >
                       + Agregar contacto
                     </button>
                   </div>
                 </div>
               </div>
             </div>

            <div class="col-md-12 text-right p-5">
              <vs-button type="gradient" button="submit">
                <i class="fa fa-save"></i>
                Guardar
              </vs-button>
            </div>
          </form>
        </div>
      </vs-tab>
      
      <vs-tab
        v-if="!client.provider && company_default.permission != 5"
        label="Cotizaciones"
        icon-pack="feather"
        icon="icon-file-text"
      >
        <div
          id="data-list-list-view"
          class="data-list-container mt-5"
          v-if="quotations.length"
        >
          <vs-table
            ref="table"
            :max-items="quotations.length"
            :data="quotations"
          >
            <template slot="thead">
              <vs-th sort-key="">Número</vs-th>
              <vs-th sort-key="">Subtotal</vs-th>
              <vs-th sort-key="">Descuento</vs-th>
              <vs-th sort-key="">IVA</vs-th>
              <vs-th sort-key="">Total</vs-th>
              <vs-th sort-key="created_at">Fecha</vs-th>
            </template>

            <template slot-scope="{ data }">
              <tbody>
                <vs-tr
                  :data="quotation"
                  :key="quotation.id"
                  v-for="(quotation, index) in data"
                >
                  <vs-td>
                    <router-link
                      class="link"
                      :to="{
                        name: 'detail-transaction',
                        params: { type: 'quotation', id: quotation.id }
                      }"
                    >
                      {{ quotation.reference }}
                    </router-link>
                  </vs-td>

                  <vs-td>
                    <calc-price
                      :price="quotation.subtotal"
                      :currency="quotation.currency_id"
                      :exchange_rate="quotation.exchange_rate"
                    >
                    </calc-price>
                  </vs-td>
                  <vs-td>
                    <calc-price
                      :price="quotation.discount"
                      :currency="quotation.currency_id"
                      :exchange_rate="quotation.exchange_rate"
                    >
                    </calc-price>
                  </vs-td>
                  <vs-td>
                    <calc-price
                      :price="quotation.tax"
                      :currency="quotation.currency_id"
                      :exchange_rate="quotation.exchange_rate"
                    >
                    </calc-price>
                  </vs-td>
                  <vs-td>
                    <calc-price
                      :price="quotation.total"
                      :currency="quotation.currency_id"
                      :exchange_rate="quotation.exchange_rate"
                    >
                    </calc-price>
                  </vs-td>
                  <vs-td>{{
                    quotation.created_at | moment("DD/MM/YYYY")
                  }}</vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </div>
        <h3 v-if="!quotations.length" class="text-center">
          Sin cotizaciones
        </h3>
      </vs-tab>
      
      <vs-tab
        v-if="!client.provider"
        label="Facturas"
        icon-pack="feather"
        icon="icon-tag"
      >
        <div>
          <registers-per-page
            @changeNumPerPage="changeNumPerPage"
          ></registers-per-page>
          <search-filter
            :perPage="perPage"
            :options="optionsFilter"
            @executeSearch="search"
          ></search-filter>
        </div>

        <div
          id="data-list-list-view"
          class="data-list-container mt-5"
          style="height: 100vh"
          v-if="invoices.length"
          v-loading="loading"
        >
          <vs-table ref="table" :max-items="perPage" :data="invoices">
            <template slot="thead">
              <vs-th>Número</vs-th>
              <vs-th>Total</vs-th>
              <vs-th v-if="company_default.permission != 5"
                >Monto pagado</vs-th
              >
              <vs-th v-if="company_default.permission != 5">Estado</vs-th>
              <vs-th sort-key="created_at">Fecha</vs-th>
              <vs-th>Hacienda</vs-th>
              <vs-th v-if="company_default.permission != 5">Acciones</vs-th>
            </template>

            <template slot-scope="{ data }">
              <tbody>
                <vs-tr
                  :data="invoice"
                  :key="invoice.id"
                  v-for="(invoice, index) in data"
                >
                  <vs-td>
                    <router-link
                      class="link"
                      :to="{
                        name: 'detail-transaction',
                        params: { type: 'invoice', id: invoice.id }
                      }"
                    >
                      {{ invoice.reference }}
                    </router-link>
                  </vs-td>
                  <vs-td>
                    <calc-price
                      :price="invoice.total"
                      :currency="invoice.currency_id"
                      :exchange_rate="invoice.exchange_rate"
                    ></calc-price>
                  </vs-td>
                  <vs-td v-if="company_default.permission != 5">
                    <calc-price
                      :price="invoice.payment_amount"
                      :currency="invoice.currency_id"
                      :exchange_rate="invoice.exchange_rate"
                    ></calc-price>
                  </vs-td>
                  <vs-td v-if="company_default.permission != 5">
                    <div>
                      <status-payment
                        :total="invoice.total"
                        :payment_amount="invoice.payment_amount"
                        :hacienda="invoice.hacienda"
                        :note_totals="invoice.note_totals"
                      >
                      </status-payment>
                    </div>
                    <br />
                    <div
                      style="padding-top:8px"
                      v-if="
                        invoice.payment_amount < invoice.total &&
                          invoice.note_totals.ncs.nc_total < invoice.total
                      "
                    >
                      <small
                        class="text-danger"
                        v-if="invoice.expiration_date.substr(0, 10) < today"
                      >
                        Vencida hace {{ invoice.days_expiration }}
                        {{ invoice.days_expiration > 1 ? "dias" : "dia" }}
                      </small>
                      <small
                        class="text-warning"
                        v-if="invoice.expiration_date.substr(0, 10) == today"
                      >
                        Vence hoy
                      </small>
                    </div>
                  </vs-td>
                  <vs-td>{{
                    invoice.created_at | moment("DD/MM/YYYY")
                  }}</vs-td>
                  <vs-td>
                    <status-hacienda
                      :status="invoice.hacienda"
                    ></status-hacienda>
                  </vs-td>
                  <vs-td v-if="company_default.permission != 5">
                    <el-dropdown @command="listAction">
                      <i class="fa fa-cogs text-primary"></i>

                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                          v-if="invoice.total > invoice.payment_amount"
                          :command="{
                            command: 'pay',
                            payload: { item: invoice }
                          }"
                          class="text-info"
                        >
                          <i class="fa fa-money-bill-alt"></i>
                          Pagar
                        </el-dropdown-item>
                        <el-dropdown-item
                          v-if="
                            invoiceExpiration(invoice.expiration_date) &&
                              invoice.payment_amount < invoice.total
                          "
                          :command="{
                            command: 'rp',
                            payload: { item: invoice }
                          }"
                          class="text-warning"
                        >
                          <i class="fa fa-envelope-open-text"></i>
                          Recordatorio de pago
                          {{
                            invoice.number_sent_remember_payment > 0
                              ? "(" +
                                invoice.number_sent_remember_payment +
                                ")"
                              : ""
                          }}
                        </el-dropdown-item>
                        <el-dropdown-item
                          :command="{
                            command: 'nc',
                            payload: { id: invoice.id }
                          }"
                          class="text-danger"
                        >
                          <i class="fa fa-minus-circle"></i>
                          Nota de crédito
                        </el-dropdown-item>
                        <el-dropdown-item
                          :command="{
                            command: 'nd',
                            payload: { id: invoice.id }
                          }"
                          class="text-success"
                        >
                          <i class="fa fa-plus-circle"></i>
                          Nota de débito
                        </el-dropdown-item>
                        <el-dropdown-item
                          :command="{
                            command: 'clone',
                            payload: { id: invoice.id }
                          }"
                          class="text-primary"
                        >
                          <i class="fa fa-clone"></i>
                          Clonar
                        </el-dropdown-item>

                        <el-dropdown-item
                          :command="{
                            command: 'recurring',
                            payload: { id: invoice.id }
                          }"
                          class="text-primary"
                        >
                          <i class="fa fa-clone"></i>
                          Hacer recurrente
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
          <div
            class="mt-4 text-center zatura-pagination"
            v-if="pageCount > 1"
          >
            <vs-pagination :total="pageCount" v-model="page"></vs-pagination>
          </div>
        </div>
        <h3 v-if="!invoices.length" class="text-center">
          Sin Facturas
        </h3>
      </vs-tab>
      
      <vs-tab
        v-if="!client.provider"
        label="Tiquetes"
        icon-pack="feather"
        icon="icon-file-text"
      >
        <div
          id="data-list-list-view"
          class="data-list-container mt-5"
          v-if="tickets.length"
          v-loading="loading"
        >
          <vs-table ref="table" :max-items="tickets.length" :data="tickets">
            <template slot="thead">
              <vs-th>Número</vs-th>
              <vs-th>Total</vs-th>
              <vs-th sort-key="created_at">Fecha</vs-th>
              <vs-th>Hacienda</vs-th>
            </template>

            <template slot-scope="{ data }">
              <tbody>
                <vs-tr
                  :data="ticket"
                  :key="index"
                  v-for="(ticket, index) in data"
                >
                  <vs-td>
                    <router-link
                      class="link"
                      :to="{
                        name: 'detail-transaction',
                        params: { type: 'ticket', id: ticket.id }
                      }"
                    >
                      {{ ticket.reference }}
                    </router-link>
                  </vs-td>
                  <vs-td>
                    <calc-price
                      :price="ticket.total"
                      :currency="ticket.currency_id"
                      :exchange_rate="ticket.exchange_rate"
                    >
                    </calc-price>
                  </vs-td>
                  <vs-td>{{
                    ticket.created_at | moment("DD/MM/YYYY")
                  }}</vs-td>
                  <vs-td>
                    <status-hacienda
                      :status="ticket.hacienda"
                    ></status-hacienda>
                  </vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </div>
        <h3 v-if="!tickets.length" class="text-center">
          Sin Tiquetes
        </h3>
      </vs-tab>
    </vs-tabs>

    <payment-modal
      @paymentExecuted="updateItem"
      @closeModal="closeModal()"
      :data="data_modal_payment"
      :vis="payment_modal_visible"
    ></payment-modal>
    <payment-remember-modal
      @closeModal="closeModal()"
      :dataEmail="data_modal_remember_payment"
      :visible="show_modal_payment_remember"
    ></payment-remember-modal>

    <!-- Manual Activity Dialog -->
    <el-dialog 
      title="Agregar Actividad Económica Manualmente" 
      :visible.sync="manualActivityDialog"
      width="500px"
    >
      <el-form>
        <el-form-item label="Código (6 dígitos) *">
          <el-input 
            v-model="manualActivity.code" 
            placeholder="Ej: 620100"
            maxlength="6"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="Descripción (Opcional)">
          <el-input 
            type="textarea" 
            v-model="manualActivity.description" 
            placeholder="Descripción de la actividad económica (opcional)"
            :rows="3"
          ></el-input>
        </el-form-item>
      </el-form>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="manualActivityDialog = false">Cancelar</el-button>
        <el-button type="primary" @click="addManualActivity">Agregar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import clientsService from "@/services/clients.service";
import utilitiesService from "@/services/utilities.service";
import CalcPrice from "@/components/CalcPrice";
import StatusPayment from "@/components/StatusPayment.vue";
import StatusHacienda from "@/components/StatusHacienda.vue";
import PaymentModal from "@/components/PaymentModal.vue";
import PaymentRememberModal from "@/components/PaymentRememberModal.vue";
import RegistersPerPage from "@/components/RegistersPerPage";
import SearchFilter from "@/components/SearchFilter.vue";

import { mapState } from "vuex";
import momentjs from "moment";

export default {
  name: "client-detail",
  components: {
    CalcPrice,
    StatusPayment,
    StatusHacienda,
    PaymentModal,
    PaymentRememberModal,
    RegistersPerPage,
    SearchFilter
  },
  data() {
    return {
      economic_activities: [],
      id: this.$route.params.id,
      client: {
        economic_activity_id: "",
        name: "",
        comercial_name: "",
        identification_type: "",
        identification: "",
        email: "",
        phone: "",
        address: "",
        country: {},
        province: {},
        canton: {},
        district: {},
        barrio: {},
        balance: 0,
        contacts: [
          {
            name: "",
            email: "",
            workstation: "",
            send_copy_email_invoices: false
          }
        ],
        provider: 0,
        economic_activity: [],
        found_company_name: null,
        found_regimen: null
      },
      quotations: [],
      invoices: [],
      tickets: [],
      payments: [],

      today: "",
      payment_modal_visible: false,
      show_modal_payment_remember: false,
      data_modal_payment: {},
      data_modal_remember_payment: {},
      searchData: {},
      pageCount: 0,
      perPage: 10,
      page: 1,
      optionsFilter: [
        { label: "Aceptado", value: "aceptado" },
        { label: "Rechazado", value: "rechazado" },
        { label: "Pagado", value: "pagado" },
        { label: "No Pagado", value: "no-pagado" }
      ],
      loading: false,
      enableActivityEditing: false,
      originalActivities: [],
      manualActivityDialog: false,
      manualActivity: {
        code: '',
        description: '',
        type: 'S'
      },
      activitiesLoading: false
    };
  },
  computed: {
    ...mapState(["current_currency", "company_default"]),
    selectedEconomicActivities() {
      // Simplificado para evitar errores
      if (!this.client.economic_activity || !Array.isArray(this.client.economic_activity)) {
        return [];
      }
      return this.client.economic_activity;
    },
    availableActivities() {
      // Combinar las actividades del cliente (si las tiene) con todas las disponibles
      const allActivities = [...this.economic_activities];
      
      // Si el cliente tiene actividades, asegurarse de que estén incluidas en la lista
      if (this.client.economic_activity && this.client.economic_activity.length > 0) {
        this.client.economic_activity.forEach(clientActivity => {
          const exists = allActivities.find(activity => 
            activity.id === clientActivity.id || 
            activity.id === clientActivity.codigo ||
            String(activity.id) === String(clientActivity.id)
          );
          if (!exists) {
            allActivities.push(clientActivity);
          }
        });
      }
      
      return allActivities;
    },
    contacts: function() {
      return this.client.contacts;
    },
    notRemoveContact() {
      return this.client.contacts.length == 1;
    },
    countries: function() {
      return this.$store.state.countries;
    },
    provinces() {
      return this.$store.state.provinces;
    },
    cantons() {
      return this.$store.state.cantons;
    },
    districts() {
      return this.$store.state.districts;
    },
    barrios() {
      return this.$store.state.barrios;
    },
    rulesIdentification() {
      if (this.client.identification_type == "01") {
        return "required|min:9|max:12";
      } else {
        return "required";
      }
    },
    identification_types() {
      return this.$store.state.identification_types;
    },
    showProvinceCantonDistrict() {
      return this.client.country.id !== 60 ? false : true;
    }
  },
  methods: {
    enableActivityEditingMode() {
      this.originalActivities = [...(this.client.economic_activity || [])];
      this.enableActivityEditing = true;
    },
    cancelActivityEditing() {
      this.client.economic_activity = [...this.originalActivities];
      this.enableActivityEditing = false;
      this.originalActivities = [];
    },
    saveActivityChanges() {
      // Las actividades ya están actualizadas en this.client.economic_activity
      this.enableActivityEditing = false;
      this.originalActivities = [];
      // Aquí podrías llamar a updateClient() si quisieras guardar automáticamente
    },
    updateSelectedActivities(newValue) {
      console.log('UPDATE - New value received:', newValue);
      this.$set(this.client, 'economic_activity', newValue);
      console.log('UPDATE - Updated client.economic_activity:', this.client.economic_activity);
    },
    invoiceExpiration(expiration_date) {
      let expiration_date_format = this.$options.filters.moment(
        expiration_date,
        "YYYY-MM-DD"
      );
      if (expiration_date_format <= momentjs().format("YYYY-MM-DD")) {
        return true;
      } else {
        return false;
      }
    },
    updateItem(item) {
      this.payment_modal_visible = false;
      let i = this.invoices.find(i => i.id === item.paymentable_id);
      let index = this.invoices.indexOf(i);
      this.invoices[index].payment_amount =
        this.invoices[index].payment_amount + parseFloat(item.amount);
      this.invoices[index].due = item.due;
      
      clientsService
        .getClientDetail(this.id)
        .then(res => {
          this.client.balance = res.data.balance;
        })
        .catch(error => {
          this.$message({
            showClose: true,
            message: error.response.data.message,
            type: "error"
          });
        });

        this.payment_modal_visible = false;
    },
    changeNumPerPage(num) {
      let searchData = this.searchData;
      searchData.perPage = num;
      this.searchData = searchData;
      this.getInvoices(1, this.searchData);
    },
    search(search) {
      this.searchData = search;
      this.searchData.perPage = this.perPage;
      this.getInvoices(1, this.searchData);
    },
    goPage(page) {
      this.getInvoices(page, this.searchData);
    },
    listAction(command) {
      switch (command.command) {
        case "pay":
          this.payment_modal_visible = true;
          this.data_modal_payment = command.payload;
          break;
        case "nc":
          this.$router.push({
            name: "new-note",
            params: {
              note_type: "nc",
              document_type: "invoice",
              document_id: command.payload.id
            }
          });
          break;
        case "nd":
          this.$router.push({
            name: "new-note",
            params: {
              note_type: "nd",
              document_type: "invoice",
              document_id: command.payload.id
            }
          });
          break;
        case "clone":
          this.$router.push({
            name: "new-clone",
            params: {
              document_type: "invoice",
              document_id: command.payload.id
            }
          });
          break;
        case "recurring":
          this.$router.push({
            name: "new-recurring",
            params: {
              document_type: "invoice",
              document_id: command.payload.id
            }
          });
          break;
        //recordatorio de pago
        case "rp":
          this.show_modal_payment_remember = true;
          this.data_modal_remember_payment = command.payload;
          break;
      }
    },
    closeModal(data) {
      this.payment_modal_visible = false;
      this.show_modal_payment_remember = false;
    },
    getEconomicActivities() {
      utilitiesService
        .getEconomicActivities()
        .then(res => {
          console.log('GET ECONOMIC ACTIVITIES - Response:', res.data);
          this.economic_activities = res.data;

          // Force reactivity update after economic_activities are loaded
          console.log('GET ECONOMIC ACTIVITIES - Current client state:', {
            'client.economic_activity': this.client.economic_activity,
            'client.economic_activities': this.client.economic_activities
          });
          
          // Ensure selected activities are updated with complete data from economic_activities
          if (this.client.economic_activity && Array.isArray(this.client.economic_activity)) {
            console.log('GET ECONOMIC ACTIVITIES - Updating selected activities with complete data');
            this.$nextTick(() => {
              this.$forceUpdate();
            });
          }
        })
        .catch(error => {
          alert(error);
        });
    },
    newDocument(type) {
      if (type === "invoice") {
        this.$router.push({ name: "new-invoice", query: { id: this.id } });
      } else if (type === "ticket") {
        this.$router.push({ name: "new-ticket", query: { id: this.id } });
      }
    },
    getClientDetail() {
      let id = this.id;
      this.loading = true;
      clientsService
        .getClientDetail(id)
        .then(res => {
          this.loading = false;
          let {
            id,
            name,
            comercial_name,
            address,
            identification_type,
            identification,
            email,
            contacts,
            phone,
            barrio,
            district,
            canton,
            province,
            country,
            quotations,
            //invoices,
            tickets,
            balance,
            generic,
            provider,
            economic_activity_id
          } = res.data;

          this.client.name = name;
          this.client.comercial_name = comercial_name;
          this.client.address = address;
          this.client.identification_type = identification_type;
          this.client.identification = identification;
          this.client.email = email;
          this.client.phone = phone;
          this.client.province = province;
          this.client.canton = canton;
          this.client.district = district;
          this.client.barrio = barrio;
          this.client.country = country;
          this.client.contacts =
            contacts.length > 0
              ? contacts
              : [
                  {
                    name: "",
                    email: "",
                    workstation: "",
                    send_copy_email_invoices: false
                  }
                ];
          this.quotations = quotations;
          //this.invoices = invoices;
          this.tickets = tickets;
          this.client.balance = balance;
          this.client.generic = generic;
          this.client.provider = provider;
          this.client.economic_activity_id = economic_activity_id;

          // If server returned economic_activity as object/string, normalize into economic_activities for the select
          if (res.data.economic_activity) {
            console.log('CLIENT DETAIL - Economic activity received from server:', {
              economic_activity: res.data.economic_activity,
              type: typeof res.data.economic_activity,
              is_array: Array.isArray(res.data.economic_activity)
            });
            
            try {
              const ea = typeof res.data.economic_activity === 'string' ? JSON.parse(res.data.economic_activity) : res.data.economic_activity;
              console.log('CLIENT DETAIL - After parsing/processing:', {
                ea: ea,
                is_array: Array.isArray(ea),
                type: typeof ea
              });
              
              if (Array.isArray(ea)) {
                this.client.economic_activities = ea;
                this.$set(this.client, 'economic_activity', ea);
                console.log('CLIENT DETAIL - Set as array (simplified):', { 
                  economic_activity: ea,
                  type: typeof ea,
                  is_array: Array.isArray(ea)
                });
              } else if (ea && typeof ea === 'object') {
                this.client.economic_activities = [ea];
                this.$set(this.client, 'economic_activity', [ea]);
                console.log('CLIENT DETAIL - Converted object to array (simplified):', { 
                  economic_activity: [ea]
                });
              }
              this.client.found_company_name = ea && (ea.company_name || (ea[0] && ea[0].company_name)) ? (ea.company_name || ea[0].company_name) : (res.data.company_name || null);
              this.client.found_regimen = ea && (ea.regimen || (ea[0] && ea[0].regimen)) ? (ea.regimen || ea[0].regimen) : (res.data.regimen || null);
              
              // Force update to ensure reactivity
              console.log('CLIENT DETAIL - Final check after assignment:', {
                'this.client.economic_activity': this.client.economic_activity,
                'this.client.economic_activities': this.client.economic_activities
              });
              
            } catch (e) {
              console.error('CLIENT DETAIL - Error parsing economic_activity:', e);
              // ignore parse errors
            }
          } else {
            console.log('CLIENT DETAIL - No economic_activity received from server');
          }

          this.getCountries();
          this.getProvinces(true);
          this.getEconomicActivities();
          this.getInvoices();
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: error.response.data.message,
            type: "error"
          });
        });
    },
    getInvoices(page = 1, search = {}) {
      this.loading = true;
      clientsService
        .getInvoicesByClient(this.id, page, search)
        .then(res => {
          this.invoices = res.data.data;
          this.loading = false;
          this.pageCount = res.data.last_page;
        })
        .catch(error => {
          this.loading = false;
          this.$message({
            showClose: true,
            message: "Ha ocurrido un error al cargar las facturas del cliente",
            type: "error"
          });
        });
    },
    updateClient() {
      this.$validator.validate().then(valid => {
        if (valid) {
          let _this = this;
          let data = this.client;
          data.id = this.id;
          
          // 🔍 Log client data before sending
          console.log('🔍 [CLIENT UPDATE] Datos del cliente a actualizar:', data);
          console.log('🔍 [CLIENT UPDATE] ID:', data.id);
          console.log('🔍 [CLIENT UPDATE] Tipo identificación:', data.identification_type);
          console.log('🔍 [CLIENT UPDATE] Actividades económicas:', data.economic_activity);
          if (data.economic_activity && data.economic_activity.length > 0) {
            console.log('🔍 [CLIENT UPDATE] Primera actividad:', data.economic_activity[0]);
          }
          
          clientsService
            .updateClient(data)
            .then(function(response) {
              console.log('✅ [CLIENT UPDATE] Respuesta del servidor:', response);
              console.log('✅ [CLIENT UPDATE] Response data:', response.data);
              
              //_this.$snotify.success('Cliente Actualizado Correctamente');
              //JRA Cambio de notificacion por mensaje
              _this.$message({
                showClose: true,
                message: "Cliente Actualizado Correctamente",
                type: "success",
                duration: 1500
              });
            })
            .catch(function(error) {
              console.error('❌ [CLIENT UPDATE] Error al actualizar:', error);
              console.error('❌ [CLIENT UPDATE] Error response:', error.response);
              
              //_this.$snotify.error(error.response.data.message);
              //JRA Cambio de notificacion por mensaje
              _this.$message({
                showClose: true,
                message: error.response.data.message,
                type: "error"
              });
            });
        }
      });
    },
    addContact(newIndex) {
      if (this.client.contacts.length == 3) {
        //this.$snotify.info(`No puede agregar mas de ${this.client.contacts.length} contactos`);
        //JRA Cambio de notificacion por mensaje
        this.$message({
          showClose: true,
          message: `No puede agregar mas de ${this.client.contacts.length} contactos`,
          type: "info"
        });
        return;
      }

      this.$set(this.client.contacts, newIndex, {
        name: "",
        email: "",
        workstation: "",
        send_copy_email_invoices: false
      });
    },
    removeContact(index) {
      if (this.client.contacts.length == 1) return;
      this.client.contacts.splice(index, 1);
    },
    getCountries() {
      this.$store.dispatch("getCountries", {});
    },
    getProvinces(preselect = false) {
      this.$store.dispatch("getProvinces", {}).then(res => {
        this.getCantons(preselect);
      });
    },
    getCantons(preselect = false) {
      this.$store
        .dispatch("getCantons", { province: this.client.province.number })
        .then(res => {
          if (!preselect) {
            this.client.canton = this.client.canton;
          }
          this.getDistricts(preselect);
        });
    },
    getDistricts(preselect = false) {
      this.$store
        .dispatch("getDistricts", {
          province: this.client.province.number,
          canton: this.client.canton.number
  })
  .then(res => {
          if (!preselect) {
            this.client.district = res[0];
          }
          this.getBarrios(preselect);
        });
    },
    getBarrios(preselect = false) {
      let province = this.client.province.number;
      let canton = this.client.canton.number;
      let district = this.client.district.number;
      this.$store
        .dispatch("getBarrios", {
          province: province,
          canton: canton,
          district: district
        })
        .then(res => {
          if (!preselect) {
            this.client.barrio = res[0];
          }
        });
    }
    ,
    async lookupActivities() {
      if (!this.client.identification || !this.client.identification_type) {
        this.$message({ type: 'warning', message: 'Ingrese tipo y número de identificación' });
        return;
      }

      if (this.client.identification_type !== '02' && this.client.identification_type !== '01') {
        this.$message({ type: 'warning', message: 'La búsqueda de actividades económicas solo aplica a cédulas físicas y jurídicas' });
        return;
      }

      try {
        const { data: res } = await utilitiesService.getActivitiesByIdentification(this.client.identification, this.client.identification_type);
        console.log('LOOKUP ACTIVITIES - Response from API:', res);
        
        if (res.success) {
          this.client.economic_activities = res.activities.map(a => ({ 
            id: a.codigo_original || a.codigo, 
            descripcion: a.descripcion, 
            name: a.descripcion,
            tipo: a.tipo,
            tipo_descripcion: a.tipo_descripcion 
          }));
          
          console.log('LOOKUP ACTIVITIES - Mapped activities:', this.client.economic_activities);
          
          this.client.found_company_name = res.company_name || null;
          this.client.found_regimen = res.regimen || null;
          
          if (this.client.economic_activities.length === 0) {
            this.$message({ type: 'info', message: 'No se encontraron actividades activas' });
          } else {
            // Auto-seleccionar la actividad principal
            const principalActivity = this.client.economic_activities.find(a => a.tipo === 'P');
            console.log('LOOKUP ACTIVITIES - Principal activity found:', principalActivity);
            
            if (principalActivity) {
              this.client.economic_activity = [principalActivity];
              console.log('LOOKUP ACTIVITIES - Set principal activity:', this.client.economic_activity);
              this.$message({ type: 'success', message: 'Actividad principal seleccionada automáticamente' });
            } else {
              // Si no hay principal, seleccionar la primera
              this.client.economic_activity = [this.client.economic_activities[0]];
              console.log('LOOKUP ACTIVITIES - Set first activity:', this.client.economic_activity);
            }
            
            console.log('LOOKUP ACTIVITIES - Final state:', {
              'client.economic_activity': this.client.economic_activity,
              'client.economic_activities': this.client.economic_activities
            });
          }
        } else {
          this.client.economic_activities = [];
          this.client.found_company_name = res.company_name || null;
          this.client.found_regimen = res.regimen || null;
          this.$message({ type: 'error', message: res.message || 'No se encontraron actividades' });
        }
      } catch (error) {
        this.$message({ type: 'error', message: 'Error conectando con Hacienda' });
      }
    },
    openManualActivityDialog() {
      this.manualActivity = {
        code: '',
        description: '',
        type: 'S'
      };
      this.manualActivityDialog = true;
    },
    addManualActivity() {
      if (!this.manualActivity.code || this.manualActivity.code.length !== 6) {
        this.$message({ type: 'warning', message: 'El código debe tener 6 dígitos' });
        return;
      }

      const description = this.manualActivity.description || `Actividad ${this.manualActivity.code}`;

      const newActivity = {
        id: this.manualActivity.code,
        codigo: this.manualActivity.code,
        descripcion: description,
        name: description,
        tipo: 'S',
        tipo_descripcion: 'Servicio'
      };

      // Agregar a la lista de actividades disponibles si no existe
      if (!this.client.economic_activities) {
        this.client.economic_activities = [];
      }
      
      const exists = this.client.economic_activities.find(a => a.id === newActivity.id);
      if (!exists) {
        this.client.economic_activities.push(newActivity);
      }

      // Agregar a la lista de seleccionados
      if (!this.client.economic_activity) {
        this.client.economic_activity = [];
      }
      
      const alreadySelected = this.client.economic_activity.find(a => a.id === newActivity.id);
      if (!alreadySelected) {
        this.client.economic_activity.push(newActivity);
        this.$message({ type: 'success', message: 'Actividad agregada exitosamente' });
      } else {
        this.$message({ type: 'info', message: 'Esta actividad ya está seleccionada' });
      }

      this.manualActivityDialog = false;
    },
  },
  watch: {
    page(newVal) {
      this.goPage(newVal);
    }
  },
  created() {
    this.getClientDetail();
    this.today = momentjs().format("YYYY-MM-DD");
  }
};
</script>

<style scoped>
.is-active {
  background: #00aec5;
  color: white !important;
}
</style>
